import React, { Component } from 'react'
import { connect } from 'react-redux'
import MainHeaderNav from '../main-header-nav'
import FolderSystem from 'components/folder/folder-system'

import {
	openModal,
	changeTitle,
	getArchivedProjects
} from 'state/actions'

import Button from 'components/button/button'
import SectionControls from 'components/controls/section-controls'

import { DragDropContext } from 'react-beautiful-dnd'

import {
	getUserRoles,
	isPremium
} from 'state/selectors'

import MobileFooterButtons from 'components/mobile/footer-buttons'

class ProjectsIndex extends Component {
	state = {
		searchTerm: '',
		isShowingArchived: false,
		isLoadingArchived: false,
		randomKey: 0
	}

	innerDragRefs = {}
	hoveredMainHeaderNavElement = null
	draggedProviderRef = null
	draggedData = null

	setInnerDragRefs = value => {
		this.innerDragRefs = value
	}

	setDraggedProviderRef = value => {
		this.draggedProviderRef = value
	}

	setHoveredMainHeaderNavElement = folderId => {
		this.hoveredMainHeaderNavElement = folderId
	}

	handleDragMouseUp = () => {
		if (this.hoveredMainHeaderNavElement && this.draggedData) {
			if (this.innerDragRefs.end) {
				this.innerDragRefs.end({
					...this.draggedData,
					destination: {
						droppableId: `folder-${this.hoveredMainHeaderNavElement}`,
						index: 0
					}
				})

				if (this.draggedProviderRef) {
					setTimeout(() => {
						try {
							this.draggedProviderRef.draggableProps.onTransitionEnd({
								propertyName: 'transform'
							})
						} catch (e) {
							console.log(e)
						}
					}, 1)
				}
			}
		}

		this.draggedData = null
	}

	componentWillMount = _ => {
		const {
			changeTitle
		} = this.props

		changeTitle('Projects')
	}

	newProject = _ => {
		const {
			openModal,
			currentAccount,
			folderChain
		} = this.props

		openModal('create', 'project', { account_id: currentAccount.id, folderChain: folderChain })
	}

	newFolder = _ => {
		const {
			openModal,
			currentAccount,
			folderChain
		} = this.props

		openModal('create', 'folder', { account_id: currentAccount.id, folderChain: folderChain })
	}

	toggleDisplay = _ => {
		let newToggleState

		if (this.state.toggleState === 0) {
			newToggleState = 1
		} else {
			newToggleState = 0
		}

		this.setState({
			toggleState: newToggleState
		})
	}

	onSearchTermChange = searchTerm => {
		this.setState({
			searchTerm
		})
	}

	toggleShowArchived = _ => {
		const isShowingArchived = !this.state.isShowingArchived

		this.setState({
			isLoadingArchived: true
		})

		const newState = {
			isLoadingArchived: false,
			isShowingArchived
		}

		if (isShowingArchived) {
			let hasFinishedLoading = false
			let hasFinishedTimeout = false

			this.props.getArchivedProjects(_ => {
				hasFinishedLoading = true

				if (hasFinishedTimeout) {
					this.setState(newState)
				}
			})

			setTimeout(_ => {
				hasFinishedTimeout = true

				if (hasFinishedLoading) {
					this.setState(newState)
				}

			}, 200)
		} else {
			setTimeout(_ => {
				this.setState(newState)
			}, 300)
		}
	}

	onDragStart = (e, a, b, c) => {
		this.draggedData = e
		if (this.innerDragRefs.start) {
			this.innerDragRefs.start(e)
		}
	}

	onDragEnd = e => {
		this.draggedData = null
		if (this.innerDragRefs.end) {
			this.innerDragRefs.end(e)
		}
	}

	render() {
		const {
			userRoles,
			currentAccount,
			folderChain,
			allFolders,
			match,
			isPremium,
		} = this.props

		if (!currentAccount) {
			return null
		}

		const {
			toggleState,
			searchTerm,
			isShowingArchived,
			isLoadingArchived,
			randomKey
		} = this.state

		const canEditProjects = (userRoles.admin || userRoles.pm || (!isPremium && !userRoles.guest))

		const navtabs = folderChain.map(folderId => {
			return allFolders[folderId]
		}).filter(Boolean)

		const mobileButtonProps = [
			{
				icon: 'folder-o',
				label: 'New folder',
				callback: this.newFolder,
				level: 'high',
			},
			{
				icon: 'star-o',
				label: 'New project',
				callback: this.newProject,
				level: 'low',
			}
		]

		const checkboxProps = [
			{
				label: 'See archived',
				isChecked: isLoadingArchived ? !isShowingArchived : isShowingArchived,
				callback: this.toggleShowArchived
			}
		]

		return (
			<div className="projects-container">
				<MobileFooterButtons
					buttons={mobileButtonProps}
				/>
				<DragDropContext
					onDragStart={this.onDragStart}
					onDragEnd={this.onDragEnd}
					key={randomKey}
				>
					<header className="main-header">
						<h1>
							Projects
						</h1>
						{
							canEditProjects ?
								<div className="button-area">
									<Button
										size="big"
										level="low"
										label="New Folder"
										icon="folder-o"
										callback={this.newFolder}
									/>
									<Button
										size="big"
										level="high"
										label="New Project"
										icon="star-o"
										callback={this.newProject}
									/>
								</div>
								: null
						}
						<MainHeaderNav
							relUrl={match.url}
							callback={(folder) => this.folderSystem.selectFolder(folder)}
							navtabs={navtabs}
							type='breadcrumbs'
							hasDragDropContext
							setHoveredMainHeaderNavElement={this.setHoveredMainHeaderNavElement}
							handleDragMouseUp={this.handleDragMouseUp}
						/>
					</header>
					<main>
						<SectionControls
							toggleState={toggleState}
							toggleChangeCallback={_ => { this.toggleDisplay() }}
							searchTerm={searchTerm}
							onSearchTermChange={this.onSearchTermChange}
							toggleOptions={this.toggleOptions}
							checkboxProps={checkboxProps}
						/>
						<FolderSystem
							searchTerm={searchTerm}
							setRef={folderSystem => {
								this.folderSystem = folderSystem
							}}
							isShowingArchived={isShowingArchived}
							hasDragDropContext
							setInnerDragRefs={this.setInnerDragRefs}
							setDraggedProviderRef={this.setDraggedProviderRef}
						/>
					</main>
				</DragDropContext>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		allFolders: state.account.entities.folders ? state.account.entities.folders : [],
		userRoles: getUserRoles(state),
		isPremium: isPremium(state)
	};
}

export default connect(mapStateToProps, {
	openModal,
	changeTitle,
	getArchivedProjects
})(ProjectsIndex)



// WEBPACK FOOTER //
// ./src/sections/projects/projects-index.jsx